import React, { useMemo } from "react";
import { IntercomProvider as IntercomLibraryProvider, IntercomProviderProps } from "react-use-intercom";
import { useAccountSelector, useReportsSelector, useUserSelector } from "store";

interface IIntercomProviderProps {
  children: React.ReactNode;
}

export const IntercomProvider: React.FC<IIntercomProviderProps> = ({ children }): JSX.Element => {
  const user = useUserSelector();
  const account = useAccountSelector();
  const reportsStatus = useReportsSelector();

  const intercomSettings: IntercomProviderProps = useMemo(() => {
    return {
      shouldInitialize: false,
      // (account && user && process.env.REACT_APP_NODE_ENV === "development") ||
      // (account && user && process.env.REACT_APP_NODE_ENV === "staging"),
      // (account && user && process.env.REACT_APP_NODE_ENV === "production"),
      autoBoot: true,
      appId: import.meta.env.VITE_INTERCOM_APP_ID as string,
      autoBootProps: {
        verticalPadding: 50,
        name: `${user.first_name}`,
        userId: `${user.id}`,
        email: `${user.email}`,
        createdAt: user.created_at,
        company: {
          companyId: `${account?.id}`,
          name: account?.name
        },
        customAttributes: {
          role: user?.role?.name,
          feature_list: {
            reports: reportsStatus
          }
        }
      }
    };
  }, [user, reportsStatus, account]);

  if (account && user && reportsStatus) {
    return <IntercomLibraryProvider {...intercomSettings}>{children}</IntercomLibraryProvider>;
  }
  return <>{children}</>;
};
